import { EMPTY_BU_PROFILE_MODEL } from "presentation/model/BuProfile/BuProfileModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: BuProfileProvider,
    useTracked: useBuProfileTracked
} = createContainer(() => useState(EMPTY_BU_PROFILE_MODEL), {concurrentMode: true});
export {BuProfileProvider, useBuProfileTracked};